import { defineStore } from 'pinia'
import { useSyncableModel } from '@/composables/useSyncableModel.js'
import { useApiResource } from '@/composables/resources/useApiResource.js'
import Economic from '@/models/Economic.js'

export const useEconomicStore = defineStore('economicStore', () => {
  let syncableModel = useSyncableModel(useApiResource('economics'), {
    className: Economic.modelName.name,
    paramKey: Economic.modelName.paramKey
  })

  function $reset() {
    syncableModel.collection.value = []
  }

  return {
    ...syncableModel,
    $reset
  }

}, {
  persist: true
})
